import { EcoInventDataset } from "@/hooks/useEcoInventDatasets";
import ImpactPill from "../Impact/ImpactPill";
import Table, { Column, TableProps } from "../Table/Table";

export const ACTIVITY_TYPES = [
  { value: "ordinary transforming activity", label: "Transforming activity" },
  { value: "market group", label: "Market group" },
  { value: "production mix", label: "Production mix" },
  { value: "market activity", label: "Market activity" },
];

export function activityTypeValueToLabel(activity: string) {
  const activityType = ACTIVITY_TYPES.find((x) => x.value === activity);
  if (activityType) return activityType.label;
  return "Unknown";
}

export interface EcoInventDatasetsTableProps
  extends Omit<Omit<TableProps<EcoInventDataset>, "columns">, "rowKey"> {
  columns?: Column<EcoInventDataset>[];
}

export const ecoInventDatasetTableColumns: Column<EcoInventDataset>[] = [
  {
    key: "reference_product_name",
    label: "Reference product",
    searchable: true,
    sortable: true,
    minWidth: "240px",
    maxWidth: "2fr",
  },
  {
    key: "activity_name",
    label: "Activity",
    searchable: true,
    sortable: true,
    maxWidth: "2fr",
    minWidth: "230px",
  },
  {
    key: "unit",
    label: "Unit",
    searchable: true,
    sortable: true,
    maxWidth: "140px",
    minWidth: "140px",
  },
  {
    key: "geography",
    label: "Geography",
    searchable: true,
    sortable: true,
    maxWidth: "180px",
    minWidth: "180px",
  },
  {
    key: "sector",
    label: "Sector",
    searchable: true,
    sortable: true,
    maxWidth: "1fr",
    minWidth: "150px",
  },
  {
    key: "special_activity_type",
    label: "Type",
    sortable: true,
    filterable: true,
    maxWidth: "175px",
    minWidth: "150px",
    renderer: (record) => activityTypeValueToLabel(record.special_activity_type),
  },
  {
    key: "impact",
    label: "Impact",
    sortable: true,
    renderer: (record) => <ImpactPill impact={record?.impact} />,
    maxWidth: "300px",
    minWidth: "250px",
  },
];

export const EcoInventDatasetTable = ({ ...props }: EcoInventDatasetsTableProps) => {
  return (
    <Table
      {...props}
      rowKey="id"
      availableFilters={{
        special_activity_type: ACTIVITY_TYPES,
      }}
      columns={props.columns || ecoInventDatasetTableColumns}
    />
  );
};
